import { ChevronRight } from 'lucide-react';
import { Link } from 'react-router-dom';
import { BreadcrumbSchema } from './SchemaMarkup';

interface BreadcrumbItem {
  label: string;
  path: string;
}

interface BreadcrumbProps {
  items: BreadcrumbItem[];
}

const SITE_URL = 'https://www.moreflexaviation.com';

function Breadcrumb({ items }: BreadcrumbProps) {
  const schemaItems = [
    { name: 'Home', url: `${SITE_URL}/` },
    ...items.map((item) => ({ name: item.label, url: `${SITE_URL}${item.path}` })),
  ];

  return (
    <nav
      aria-label="Breadcrumb"
      className="bg-gray-50 py-3 border-b border-gray-200 pt-[104px] lg:pt-[136px]"
    >
      <BreadcrumbSchema items={schemaItems} />
      <div className="container mx-auto px-4">
        <ol className="flex items-center flex-wrap gap-y-1 space-x-2 text-xs md:text-sm font-medium">
          <li>
            <Link to="/" className="text-gray-500 hover:text-[#73BDF2] transition-colors duration-300">
              Home
            </Link>
          </li>
          {items.map((item, index) => (
            <li key={index} className="flex items-center space-x-2">
              <ChevronRight size={14} className="text-gray-300" />
              {index === items.length - 1 ? (
                <span className="text-[#0b1220] font-semibold">{item.label}</span>
              ) : (
                <Link to={item.path} className="text-gray-500 hover:text-[#73BDF2] transition-colors duration-300">
                  {item.label}
                </Link>
              )}
            </li>
          ))}
        </ol>
      </div>
    </nav>
  );
}

export default Breadcrumb;
